import React from 'react';
import _ from 'lodash';
import HomeIcon from '@material-ui/icons/Home';
import BottomNavigationMui from '@material-ui/core/BottomNavigation';
import BottomNavigationActionMui from '@material-ui/core/BottomNavigationAction';
import { withStyles } from '@material-ui/core/styles';
import { mainColor, BORDER_RADIUS, UNIT } from '../../constants/theme';
import { NavigationIcons } from 'src/pages/Drivers/Drivers.services';

// This const declaration "BottomNavigation" takes the initial BottomNavigationMui of Material UI as the starting point
// and then we personalize it in order to have our own re-usable component, we call it : "BottomNavigationIcon"
const BottomNavigation = withStyles({
  root: {
    backgroundColor: 'transparent !important'
  }
})(BottomNavigationMui);

const BottomNavigationAction = withStyles({
  iconOnly: {
    padding: UNIT * 0.3125
  },
  selected: {
    color: 'black !important',
    whiteSpace: 'break-spaces'
  }
})(BottomNavigationActionMui);

type BottomNavigationIconProps = {
  collection?: NavigationIcons[];
  value?: number,
  onChange?: (e: React.ChangeEvent<HTMLInputElement>, value: number) => void,
  style?: React.CSSProperties,
  showLabels?: boolean,
  selectedTab?: any
}

const BottomNavigationIcon = ({ collection, value, onChange, style, showLabels, selectedTab }: BottomNavigationIconProps) => {
  return (
    <>
      <BottomNavigation showLabels={showLabels} value={value} onChange={onChange}>
        {_.map(collection, (c: NavigationIcons, index: number) => {
          const { label, icon } = c;
          return (
            <BottomNavigationAction
              key={index}
              label={
                (value === index || showLabels) && (
                  <p
                    className='truncText'
                    style={{
                      color: showLabels ? 'black' : undefined,
                      marginTop: showLabels ? UNIT * 0.5625 : undefined,
                      fontSize: showLabels ? UNIT * 0.9375 : undefined
                    }}
                  >
                    {label}
                  </p>
                )
              }
              selected={selectedTab}
              value={index}
              icon={icon || <HomeIcon />}
              style={{
                maxWidth: '100%',
                borderRadius: showLabels ? UNIT * 0.625 : BORDER_RADIUS,
                backgroundColor:
                  value === index
                    ? showLabels
                      ? 'rgba(64, 185, 143, 0.2)'
                      : `${mainColor.hexa}69`
                    : 'white',
                ...style
              }}
            />
          );
        })}
      </BottomNavigation>
    </>
  );
};

export default BottomNavigationIcon;